import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';

export function trackTriedToChangeInputSelection() {
  track(segmentTrackEvents.signup_tried_to_change_input_selection);
}
